<div ngClass.xs="size-mobile" class="wrapper">

  <app-header *ngIf="loggedIn && showHeader" class="header"></app-header>

  <div class="body">
    <router-outlet ></router-outlet>
  </div>

</div>
